import { FC, PropsWithChildren } from 'react';

import { ResourceRoutePreviewContext, ResourceRoutePreviewValue } from './context';

interface ResourceRoutePreviewProviderProps extends PropsWithChildren {
    value: ResourceRoutePreviewValue;
}

export const ResourceRoutePreviewProvider: FC<ResourceRoutePreviewProviderProps> = ({ children, value }) => (
    <ResourceRoutePreviewContext.Provider value={value}>{children}</ResourceRoutePreviewContext.Provider>
);
